<template>
  <div class="coder-page">
    <div class="coder-content">
      <div class="coder-panel">
        <div class="coder-header">
          <div class="header-left">
            <div class="connection-status">
              <div class="status-dot" :class="connected ? 'connected' : 'disconnected'"></div>
              <span>{{ connected ? '已连接' : '未连接' }}</span>
            </div>
          </div>
          
          <div class="header-center">
            <input v-model="stdin" placeholder="输入 stdin 内容..." class="stdin-input"/>
          </div>
          
          <div class="header-right">
            <select v-model="language" @change="changeLanguage" class="language-select">
              <option value="processing">Processing</option>
              <option value="cpp">C++</option>
              <option value="py3">Python</option>
              <option value="java">Java</option>
            </select>
            
            <button @click="saveToFile" class="action-btn save-btn">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
                <polyline points="17 21 17 13 7 13 7 21"/>
                <polyline points="7 3 7 8 15 8"/>
              </svg>
              <span>保存</span>
            </button>
          </div>
        </div>
        
        <editor 
          v-model="code" 
          lang="java" 
          theme="chrome" 
          class="editor"
          ref="aceEditor" 
          id="codeEditor"
          :options="editorOptions"
        ></editor>

        <div v-if="resultText!=null" class="result-panel">
          <div class="result-header">
            <span>运行结果</span>
            <button class="close-btn" @click="resultText = null">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>
          </div>
          <div class="result-content" v-html="resultText"></div>
        </div>
      </div>

      <div v-if="language == 'processing'" class="preview-panel">
        <div class="preview-header">
          <span>预览</span>
        </div>
        <div class="preview-content">
          <canvas ref="canvas"></canvas>
        </div>
      </div>
    </div>

    <div class="action-buttons">
      <div class="status-indicator">
        <img v-if="result === 1" src="/images/right.png" class="status-icon success"/>
        <img v-if="result === 0" src="/images/error.png" class="status-icon error"/>
      </div>
      <button @click="run" class="btn btn-primary" :disabled="running">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polygon points="5 3 19 12 5 21 5 3"/>
        </svg>
        <span>{{ running ? '运行中...' : '运行' }}</span>
      </button>
      <button @click="stop" class="btn btn-secondary">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="6" y="6" width="12" height="12"/>
        </svg>
        <span>清除</span>
      </button>
    </div>
  </div>
</template>

<script>
import editor from 'vue2-ace-editor'
import bus from '../utils/bus';
import util from '../utils/util';
require('brace/mode/java');
require('brace/theme/chrome');

export default {
  data() {
    return {
      code: "",
      processing: null,
      language:"cpp",
      connected:false,
      running:false,
      resultText:null,
      stdin:"",
      loopCheck:true,
      result:-1,
      error:null,
      editorOptions: {
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        enableSnippets: false,
        enableLinking: false,
        foldStyle: 'manual',
        showGutter:true,
      },
      socket:null,
    };
  },
  components:{
    editor
  },
  mounted() {
    var lang = window.localStorage.getItem("codingLang");
    if(lang != null && lang != ''){
      this.language = lang;
    }
    
    this.$nextTick(() => {
      setTimeout(() => {
        const aceInput = document.getElementsByClassName("ace_text-input")[0];
        if (aceInput) {
          aceInput.addEventListener('paste', this.handlePaste);
          aceInput.addEventListener('input', this.handleInput);
        }
      }, 500);
    });
    
    this.connectLoop();
  },
  methods: {
    handleInput() {
      if(this.socket != null && this.socket.readyState === WebSocket.OPEN) {
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
        try{
          this.socket.send(sendStr);
        }
        catch(err){
          console.log('Send error:', err);
        }
      }
    },
    connectLoop(){
      var mobile = util.getSearchString("mobile");
      var target = util.getSearchString("target");

      if(mobile != null && mobile != ""){
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
        
      }
      else{
        mobile = 's1';
        target = 't1';
        if(!this.connected){
          this.connectServer();
        }

        var interval = setInterval( ()=>{
          if(!this.connected){
            this.connectServer();
          }
          else{
            clearInterval(interval);
          }
        },5000);
      }
    },
    handlePaste(){
      if(this.socket != null){
        var mobile = util.getSearchString("mobile");
        var target = util.getSearchString("target");
        if(mobile == null || mobile == ""){
          mobile = 's1';
          target = 't1';
        }

        if(mobile == null || mobile == ""){
          return;
        }
        var sendStr = JSON.stringify({ type: 'classcode', value: this.code, target:target, from:mobile});
        try{
          this.socket.send(sendStr);
        }
        catch(err){
          console.log('Paste send error:', err);
        }
      }
    },
    connectServer(){
      var mobile = util.getSearchString("mobile");
      var target = util.getSearchString("target");

      if(mobile == null || mobile == ""){
        mobile = 's1';
        target = 't1';
      }
      
      const socket = new WebSocket('wss://wss.dctechonline.cn:8024');
      this.socket = socket;

      socket.addEventListener('open', event1 => {
        console.log('WebSocket connection established.');
        
        socket.send(JSON.stringify(
          {
            type:"user",
            mobile:mobile,
            target:target,
            classType:'coder',
          }));

        var interval2 = setInterval( ()=>{
          if(this.loopCheck == false){
            clearInterval(interval2);
            this.connected = false;
            this.connectLoop();
            return;
          }
          else{
            socket.send(JSON.stringify(
            {
              type:"loopcheck",
              mobile:mobile
            }))
            this.loopCheck = false;
            console.log('check successful');
          }
        },20000);

        this.connected = true;

        socket.addEventListener('message', event => {
          const reader = new FileReader();
          reader.addEventListener('loadend', () => {
            const text = reader.result;
            const data = JSON.parse(text);
            const { type, value,from } = data;
            console.log(data);
            if (type === 'classcode' && from == target) {
              this.code = value;
            }
            else if(type ==="loopcheck"){
              this.loopCheck = true;
            }
          });
          reader.readAsText(event.data);
        });
      });
    },
    changeLanguage(e){
      window.localStorage.setItem("codingLang", e.target.value);
      this.code = "";
      this.resultText = null;
    },
    saveToFile() {
      const content = this.code;
      const blob = new Blob([content], { type: 'text/plain' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      
      if(this.language == 'processing'){
        a.download = 'code.pde';
      }
      else if(this.language == 'cpp'){
        a.download = 'code.cpp';
      }
      else if(this.language == 'py3'){
        a.download = 'code.py';
      }
      else if(this.language == 'java'){
        a.download = 'Main.java';
      }
      
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    },
    run() {
      if(this.running){
        return;
      }

      this.running = true;

      if(this.language == 'py3'){
        var postInfo = {};
        postInfo.code = encodeURIComponent(this.code);
        postInfo.language = 15;
        postInfo.stdin = this.stdin;
        postInfo.fileext = "py3";

        this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
          console.log(response.data);
          this.running = false;
          this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
        });
        return;
      }

      else if(this.language == 'cpp'){
        var postInfo = {};
        postInfo.code = encodeURIComponent(this.code);
        postInfo.language = 7;
        postInfo.stdin = this.stdin;
        postInfo.fileext = "cpp";

        this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
          console.log(response.data);
          this.running = false;
          this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
        });
        return;
      }

      else if(this.language == 'java'){
        var postInfo = {};
        postInfo.code = encodeURIComponent(this.code);
        postInfo.language = 8;
        postInfo.stdin = this.stdin;
        postInfo.fileext = "java";

        this.$http.post("https://aiapi.dctechonline.cn/api/runcode",postInfo).then(response => {
          console.log(response.data);
          this.running = false;
          this.resultText = response.data.output != '' ? response.data.output.replace(/\n/g, '<br>') : response.data.errors.replace(/\n/g, '<br>')
        });
        return;
      }

      this.result = -1;
      this.error = null;
      if(this.processing != null){
        this.processing.exit();
        this.processing = null;
      }

      var elements1 = document.getElementsByClassName("ace_gutter-cell");
      for(var i=0;i<elements1.length;i++){
        elements1[i].className = "ace_gutter-cell";
      }

      try{
        this.processing = new Processing(this.$refs.canvas, this.code);
        console.log(this.processing)
        this.result = 1;
        this.running = false;
      }
      catch(err){
        this.result = 0;
        this.error = err;
        console.log(err);
        this.running = false;
      } 
    },
    stop() {
      this.code = "";
      this.result = -1;
      this.error = null;
      if(this.processing != null){
        this.processing.exit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';
@import '../styles/mixins.scss';

.coder-page {
  position: fixed;
  top: 72px;
  left: 0;
  width: 100%;
  height: calc(100% - 72px);
  background: $bg-secondary;
  display: flex;
  flex-direction: column;
}

.coder-content {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.coder-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fafafa;
  position: relative;
  overflow: hidden;
}

.coder-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: white;
  border-bottom: 1px solid $border-color;
  gap: 16px;
  flex-shrink: 0;
  
  @include responsive(md) {
    flex-wrap: wrap;
    padding: 10px 16px;
  }
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.connection-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: $text-secondary;
  
  .status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    
    &.connected {
      background: #10b981;
      box-shadow: 0 0 8px rgba(16, 185, 129, 0.5);
    }
    
    &.disconnected {
      background: #ef4444;
      box-shadow: 0 0 8px rgba(239, 68, 68, 0.5);
    }
  }
}

.header-center {
  flex: 1;
  max-width: 400px;
  
  @include responsive(md) {
    order: 3;
    max-width: 100%;
    width: 100%;
  }
}

.stdin-input {
  width: 100%;
  padding: 8px 14px;
  background: $bg-secondary;
  border: 1px solid $border-color;
  border-radius: 8px;
  color: $text-primary;
  font-size: 13px;
  transition: all $transition-fast;
  
  &:focus {
    outline: none;
    border-color: $primary-color;
    box-shadow: 0 0 0 3px rgba($primary-color, 0.1);
  }
  
  &::placeholder {
    color: $text-muted;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.language-select {
  padding: 8px 14px;
  background: $bg-secondary;
  border: 1px solid $border-color;
  border-radius: 8px;
  color: $text-primary;
  font-size: 13px;
  cursor: pointer;
  transition: all $transition-fast;
  
  &:focus {
    outline: none;
    border-color: $primary-color;
  }
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all $transition;
  border: none;
  
  svg {
    width: 16px;
    height: 16px;
  }
  
  &.save-btn {
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    
    &:hover {
      background: rgba($primary-color, 0.15);
    }
  }
}

.editor {
  flex: 1;
  width: 100%;
  background: white !important;
  font-size: 14px !important;
}

.result-panel {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  border-top: 1px solid $border-color;
  max-height: 200px;
  display: flex;
  flex-direction: column;
  z-index: 10;
}

.result-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: $bg-secondary;
  border-bottom: 1px solid $border-color;
  font-size: 13px;
  font-weight: 600;
  color: $text-primary;
  
  .close-btn {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    color: $text-muted;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all $transition-fast;
    
    svg {
      width: 16px;
      height: 16px;
    }
    
    &:hover {
      color: $text-primary;
      background: rgba(0, 0, 0, 0.05);
    }
  }
}

.result-content {
  flex: 1;
  padding: 12px 16px;
  overflow-y: auto;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  color: $text-primary;
  line-height: 1.6;
  
  @include scroll-style;
}

.preview-panel {
  width: 400px;
  background: white;
  border-left: 1px solid $border-color;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  
  @include responsive(lg) {
    display: none;
  }
}

.preview-header {
  padding: 12px 16px;
  background: $bg-secondary;
  border-bottom: 1px solid $border-color;
  font-size: 13px;
  font-weight: 600;
  color: $text-primary;
}

.preview-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  
  canvas {
    max-width: 100%;
    max-height: 100%;
  }
}

.action-buttons {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  gap: 12px;
  z-index: 100;
  
  .btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 12px;
    cursor: pointer;
    transition: all $transition;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    
    svg {
      width: 18px;
      height: 18px;
    }
    
    &.btn-primary {
      background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
      color: white;
      
      &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 30px rgba(99, 102, 241, 0.5);
      }
      
      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
    
    &.btn-secondary {
      background: white;
      color: $text-primary;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 30px rgba(0, 0, 0, 0.15);
      }
    }
  }
}

.status-indicator {
  display: flex;
  align-items: center;
  
  .status-icon {
    width: 28px;
    height: 28px;
    
    &.success {
      filter: drop-shadow(0 0 4px rgba($success-color, 0.5));
    }
    
    &.error {
      filter: drop-shadow(0 0 4px rgba($danger-color, 0.5));
    }
  }
}
</style>

<style lang="scss">
@import '../styles/variables.scss';

.coder-page {
  .ace_print-margin {
    display: none;
  }
  
  .ace_gutter {
    background: #f8f9fa !important;
    color: $text-muted !important;
  }
  
  .ace_gutter-active-line {
    background: rgba($primary-color, 0.1) !important;
  }
  
  .ace_gutter-cell.error-line {
    background: orangered;
    color: white;
  }
  
  .ace_gutter-cell .ace_fold-widget {
    display: none !important;
  }
  
  .ace_cursor {
    color: $text-primary !important;
  }
  
  .ace_identifier {
    color: #1890ff;
  }

  .ace_numeric {
    color: #52c41a !important;
  }

  .ace_keyword {
    color: #722ed1 !important;
  }
  
  .ace_string {
    color: #fa8c16 !important;
  }
  
  .ace_comment {
    color: #8c8c8c !important;
    font-style: italic;
  }
  
  .ace_function {
    color: #13c2c2 !important;
  }
  
  .ace_variable {
    color: #eb2f96 !important;
  }
  
  .ace_constant {
    color: #faad14 !important;
  }
}
</style>
